import { FC } from 'react'
import dynamic from 'next/dynamic'
import clsx from 'clsx'

import AgreeButton from './agree-button'
import AbandonButton from './abandon-button'
const DateBlock = dynamic(() => import('./date-block'), { ssr: false })
import SubscribersGet from 'components/parts/subscribers-get/subscribers-get'
import { useAuth } from 'store/auth/useAuth'

import { AvailableSubscribeStatus, SubscribeStatus } from 'constants/webinar-data'

import styles from './webinar-start-info.module.scss'

interface IWebinarStartInfo {
  id: number
  status: AvailableSubscribeStatus
  activeButton: boolean
  startDate?: Date
  modificator?: string
  points?: number | null
  handleChangeState: () => void
}

const WebinarStartInfo: FC<IWebinarStartInfo> = ({
  id,
  status,
  points,
  activeButton,
  startDate,
  modificator,
  handleChangeState,
}: IWebinarStartInfo) => {
  const { isAuthorized } = useAuth()
  const showEarnings = isAuthorized || Boolean(points)

  return (
    <div
      className={clsx(styles.startWebinarBlock, {
        [modificator as string]: modificator,
      })}
    >
      <div className={styles.startWebinarWrapper}>
        <DateBlock startDate={startDate} />
        <div className={styles.subscribeWrapper}>
          <SubscribersGet
            id={id}
            text={'человек уже идут'}
            modificator={styles.subscribers}
            noIcon
            alwaysShow
          />
          <div className={styles.agreeButton} onClick={handleChangeState}>
            {status === SubscribeStatus.SUBSCRIBED ? (
              <AbandonButton isActive={activeButton} />
            ) : (
              <AgreeButton isActive={activeButton} AData={{ id }} />
            )}
          </div>
        </div>
        {showEarnings && (
          <div className={styles.earningsWrap}>
            {!!points && <span className={styles.earningsText}>Вебинар подан на аккредитацию</span>}
          </div>
        )}
      </div>
    </div>
  )
}

export default WebinarStartInfo
